import Vue from 'vue'
import vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(vuex);

const state = {
    isLogin: false,
    username: null,
    userId: null,
    pid: null,
    alipay: null,//支付宝账号
    bankName: null,//开户行
    cardNomber: null,//银行卡号
    bank_account: null,// 账号名称
    openid: null,//微信openid
    truename: null,// 真实姓名
    userType: '-2',
    startTime: '2019-06-30',
    endTime: '2019-07-08',
    userPhone: '',//手机号
    test: '',
    original_p: "",//原始密码
    show_pop_old_time: 0,//插屏显示的上一次时间
    search_value_datas:[],//搜索历史数据
    channel_username: null,//二级域名的channel_name
    channel_userId: null,//
    channel_pid: null,//二级域名的channel_id

    isClearLoginData: true,//清除登录信息标记
    query_sku_data_from_robot_time: 0,//查询群主提交内容的发品列表的时间

    taobao_pid: '',//淘宝推广位ID
    wx_name: '',//微信昵称
    wx_img: '',//微信头像
    pdd_pid: '',//拼多多推广位ID
    meituan_pid: '',//美团pid

    jd_hot_words: '',//热词

    channel_pdd_pid: '',//二级域名的拼多多pid
    channel_tb_pid: '',//二级域名的淘宝pid

    pay_start_day: 0,//提款开始日期
    pay_end_day: 0,//提款截止日期
};

const getters = {
    isLogin(state) {
        // state.isLogin = localStorage.getItem('isLogin');   //从localStorage中读取状态
        // state.username = localStorage.getItem('username');
        // state.userId = localStorage.getItem('userId');
        // state.pid = localStorage.getItem('pid');
        // state.alipay = localStorage.getItem('alipay');
        // state.bankName = localStorage.getItem('bankName');
        // state.cardNomber = localStorage.getItem('cardNomber');
        // state.bank_account = localStorage.getItem('bank_account');
        // state.openid = localStorage.getItem('openid');
        // state.truename = localStorage.getItem('truename');
        if (state.isLogin === 'true' || state.isLogin === true) {
            return true
        } else {
            return false
        }
        
    }
};

const mutations = {
    test(state, str){
        state.test = str;
    },
    setJdHotWords(state, jd_hot_words){
        state.jd_hot_words = jd_hot_words;
    },
    setShowPopOldTime(state, time){
        state.show_pop_old_time = time;
    },
    setSearchValues(state, datas){
        state.search_value_datas = datas;
    },
    setLoginStatus(state, status){
        state.isLogin = status;
    },
    saveChannelData(state, channel){
        state.channel_username = channel.username;
        state.channel_userId = channel.userId;
        state.channel_pid = channel.pid;
        state.channel_pdd_pid = channel.pdd_pid;
        state.channel_tb_pid = channel.tb_pid;
    },
    setClearLoginTag(state, tag){
        state.isClearLoginData = tag;
    },

    setQuerySkuDataTime(state, time){
        state.query_sku_data_from_robot_time = time;
    },
    setPayStartDay(state, start_day){
        state.pay_start_day = start_day
    },
    setPayEndDay(state, end_day){
        state.pay_end_day = end_day;
    },
    //登陆
    login(state, user) {
        // 登录
        // 先让登录状态变为登录了
        // 若只是改变state里的值，在强制刷新后会丢失，数据添加到localStorage里
        // localStorage.setItem("username", user.username);
        // localStorage.setItem("userId", user.userId);
        // if (user.pid) {
        //     localStorage.setItem("pid", user.pid);
        // }
        // localStorage.setItem("isLogin", true);
        // localStorage.setItem("alipay", user.alipay);
        // localStorage.setItem("bankName", user.bankName);
        // localStorage.setItem("cardNomber", user.cardNomber);
        // localStorage.setItem("bank_account", user.bank_account);
        // localStorage.setItem("openid", user.openid);
        // localStorage.setItem("truename", user.truename);

        state.username = user.username;
        state.userId = user.userId;
        state.pid = user.pid;
        state.alipay = user.alipay;
        state.bankName = user.bankName;
        state.cardNomber = user.cardNomber;
        state.bank_account = user.bank_account;
        state.openid = user.openid;
        state.truename = user.truename;
        state.userType = user.userType;
        state.isLogin = true;
        state.userPhone = user.userPhone;
        state.taobao_pid = user.taobao_pid;
        state.wx_name = user.wx_name;
        state.wx_img = user.wx_img;
        state.pdd_pid = user.pdd_pid;
        state.meituan_pid = user.meituan_pid;
    },
    // 登出
    logout(state) {
        // 这个同理
        // localStorage.removeItem("username");
        // localStorage.removeItem("userId");
        // localStorage.removeItem("pid");
        // localStorage.removeItem("isLogin");
        // localStorage.removeItem("alipay");
        // localStorage.removeItem("bankName");
        // localStorage.removeItem("cardNomber");
        // localStorage.removeItem("bank_account");
        // localStorage.removeItem("openid");
        // localStorage.removeItem("truename");
        state.username = '';
        state.userId = '';
        state.pid = '';
        state.isLogin = false;
        state.alipay = '';
        state.bankName = '';
        state.cardNomber = '';
        state.bank_account = '';
        state.openid = '';
        state.truename = '';
        state.userType = '-2';
        state.userPhone = '';
        state.taobao_pid = '';
        state.wx_name = '';
        state.wx_img = '';
        state.pdd_pid = '';
        state.meituan_pid = '';
        state.pay_start_day = 0;
        state.pay_end_day = 0;

    },
    startTime(state, sTime) {
        state.startTime = sTime
    },
    endTime(state, eTime) {
        state.endTime = eTime
    }
};

const actions = {};


const vuexLocal = new VuexPersistence({
    storage: window.localStorage
});

export default new vuex.Store({
    state,
    getters,
    mutations,
    actions,
    plugins: [vuexLocal.plugin]
})
